import ShoppingCartPage from './shoppingCartPage';

export default ShoppingCartPage;